module.exports = __webpack_public_path__ + "img/lastcardA.ce4008d3.png";